import styled from 'styled-components';
import { Table } from 'antd';

const StyledTable = styled(Table)`
  margin: ${({ margin }) => margin};
  border-top: 1px solid var(--neutral-2);
  border-right: 1px solid var(--neutral-2);
  border-left: 1px solid var(--neutral-2);
  box-shadow: 0px 3px 10px rgba(11, 26, 33, 0.08);
  max-width: 100%;
  overflow: scroll;

  .ant-table thead {
    tr {
      th {
        background: var(--neutral-text-color);
        padding: 25px 25px;
        text-align: center;

        @media (max-width: 768px) {
          padding: 15px 15px 10px 15px;
        }

        &:first-child {
          text-align: left;
        }

        h6 {
          font-weight: 400;

          @media (max-width: 768px) {
            font-size: 16px;
          }
        }
      }

      &:first-child {
        th:last-child,
        th:first-child {
          border-radius: 0px;
        }
      }
    }

    .table--serviceTitanColumn-cell {
      background: var(--blue-primary);
      padding: 15px 15px;

      @media (max-width: 768px) {
        padding: 15px;
      }
    }

    .table--st-logo {
      svg {
        height: 35px;

        @media (max-width: 768px) {
          height: 25px;
        }
      }
    }
  }
  .ant-table-tbody {
    tr {
      td {
        padding: 15px 25px;
        text-align: center;
        font-size: 16px;
        color: var(--normal-description-color);

        @media (max-width: 768px) {
          padding: 10px 15px 8px 15px;
          font-size: 13px;
          min-width: 125px;
        }

        &:first-child {
          text-align: left;
        }
      }
      &:last-child {
        .table--serviceTitanColumn-cell {
          border-bottom: 1px solid var(--blue-primary);
        }
      }
    }
  }

  .table--subhead {
    background: var(--blue-fourth);

    td {
      color: var(--neutral-text-color);
    }
  }

  .table--zebra {
    background: rgba(196, 196, 196, 0.1);
  }

  .table--serviceTitanColumn-cell {
    border-left: 1px solid var(--blue-primary);
    border-right: 1px solid var(--blue-primary);
  }
`;

export { StyledTable };
